const configurationReducer = (config = null, action) => {
    let newConfig = null;

    switch(action.type) {
        case 'SET_CONFIG':
            return action.payload;
        case 'SET_CONSENT':
            newConfig = {...config};
            newConfig.vendorConsent = {...action.payload};
            return newConfig;
        case 'SET_PURPOSECONSENT':
            newConfig = {...config};
            newConfig.purposeConsent = {...action.payload};
            return newConfig;
        case 'SET_PURPOSELEGITIMATEINTEREST':
            newConfig = {...config};
            newConfig.purposeLegitimateInterest = {...action.payload};
            return newConfig;
        case 'SET_OBJECTCONSENT':
            newConfig = {...config};
            newConfig.objectConsent = {...action.payload};
            return newConfig;
        case 'SET_SPECIALFEATURESCONSENT':
            newConfig = {...config};
            newConfig.specialFeatureOptins = {...action.payload};
            return newConfig;
        default:
            return config;
    }
};

export default configurationReducer;